import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
export function ScrollProgress() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 260,
    damping: 40,
    mass: 0.3
  });
  return <motion.div aria-hidden="true" style={{
    scaleX
  }} className="fixed inset-x-0 top-0 z-[70] h-[2px] origin-left bg-gold-400" data-id="element-282" data-mp="ik46qqz0gg3" />;
}